module.exports = __webpack_public_path__ + "static/media/Table-7-3.386ebf05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Table-7-3.svg
// module id = 768
// module chunks = 0